import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { EndCustomerWithLanguageDto } from 'modules/EndCustomer/Shared/types';
import { OperatingLocationFormType } from 'modules/Shared/Components/OperatingLocation/OperatingLocationForm';

import { AddCustomerState, SourceType } from './Types';

const initialState: AddCustomerState = {
	unitId: 0,
	unitPublicId: '',
	owner: null,
	ownerSourceType: null,
	unitManagerSourceType: null,
	operatingLocation: null,
};

export const addEndCustomerSlice = createSlice({
	name: 'addEndCustomer',
	initialState,
	reducers: {
		initializeState: (
			state,
			{ payload }: PayloadAction<{ id: number; publicId: string }>
		) => {
			if (!isNaN(payload.id) && payload.id >= 0) {
				// reset state
				return {
					...initialState,
					unitId: payload.id,
					unitPublicId: payload.publicId,
				};
			}

			return state;
		},
		setUnitId: (
			state,
			{ payload }: PayloadAction<{ id: number; publicId: string }>
		) => {
			if (!isNaN(payload.id) && payload.id >= 0) {
				// reset state
				return {
					...initialState,
					unitId: payload.id,
					unitPublicId: payload.publicId,
				};
			}

			return state;
		},
		ownerChanged: (
			state,
			{ payload }: PayloadAction<EndCustomerWithLanguageDto>
		) => {
			state.owner = payload;
		},
		ownerSourceChanged: (state, { payload }: PayloadAction<SourceType>) => {
			state.ownerSourceType = payload;
		},
		unitManagerChanged: (
			state,
			{ payload }: PayloadAction<EndCustomerWithLanguageDto>
		) => {
			state.unitManager = payload;
		},
		unitManagerSourceChanged: (
			state,
			{ payload }: PayloadAction<SourceType>
		) => {
			state.unitManagerSourceType = payload;
		},
		clearCustomerData: (state, { payload }: PayloadAction<boolean>) => {
			if (payload) {
				state.owner = null;
			} else {
				state.unitManager = undefined;
			}
		},
		operatingLocationChanged: (
			state,
			{ payload }: PayloadAction<OperatingLocationFormType>
		) => {
			state.operatingLocation = payload;
		},
	},
});

export const {
	initializeState,
	setUnitId,
	ownerChanged,
	ownerSourceChanged,
	unitManagerChanged,
	unitManagerSourceChanged,
	clearCustomerData,
	operatingLocationChanged,
} = addEndCustomerSlice.actions;

export default addEndCustomerSlice.reducer;
